import { apiFetch } from './apiFetch';

export async function validateName(name) {
  try {
    const response = await apiFetch(`/name?name=${name}`);

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await response.json();

    // Assuming your API returns { valid: true/false }
    return data.is_valid === true;
  } catch (error) {
    console.error('Error validating name:', error);
    throw error;
  }
}
